window.JBInitializeDeepPages = () => {
  if (window.JBListingEditorRedirecting) return;
  window.JBListingEditor?.prepare();
  const durations = {
    '3-hours': '3 Hours', '1-day': '1 Day', '2-days': '2 Days',
    '3-days': '3 Days', '4-days': '4 Days', '5-days': '5 Days', '7-days': '7 Days'
  };
  const series = {
    hutongs: {
      title: 'Hutongs & Local Life', topics: 'LOCAL LIFE   COURTYARDS   HIDDEN ALLEYS',
      tagline: 'Three intimate ways to experience old Beijing.',
      description: 'Step away from the main sights and into the living heart of the city. Explore neighborhood lanes, courtyards and local stories through a journey shaped around your interests.',
      choice: 'Choose one path into old Beijing.', hero: 'interest-hutong.png',
      ideal: 'Local-life interests', style: 'Local Life',
      features: [
        ['Historic hutong lanes', 'A closer look at Beijing’s old streets.', 'interest-hutong.png'],
        ['Local courtyards', 'Architecture and everyday neighborhood life.', 'interest-culture.png'],
        ['Stories of the city', 'Perspectives that connect place and people.', 'interest-food.png']
      ],
      listings: [
        ['Hutong Stories', 'Drum Tower, Baochao Hutong & Shichahai', 'interest-hutong.png', 'Wander historic lanes and discover the living heart of old Beijing.'],
        ['White Pagoda & Hidden Hutongs', 'Baitasi, Gongmenkou & Xisi', 'interest-culture.png', 'A closer look at quiet lanes and neighborhood heritage.'],
        ['Courtyards & Everyday Life', 'Dongsi, Shijia Hutong & neighborhood lanes', 'interest-hutong.png', 'Explore the textures of courtyard life and local streets.']
      ]
    },
    culture: {
      title: 'Culture & Heritage', topics: 'HISTORY   ARCHITECTURE   STORIES',
      tagline: 'Different ways to see Beijing’s living heritage.',
      description: 'Explore the places, traditions and layers of history that give Beijing its character. Choose a perspective and shape the details together.',
      choice: 'Choose the story you want to follow.', hero: 'interest-culture.png',
      ideal: 'Heritage interests', style: 'Culture',
      features: [
        ['Landmark perspectives', 'See familiar places from a new angle.', 'interest-culture.png'],
        ['Design & detail', 'Look closer at architecture and symbolism.', 'curated-tours-beijing.png'],
        ['Living traditions', 'Connect old stories with the city today.', 'interest-hutong.png']
      ],
      listings: [
        ['Imperial Perspectives', 'Architecture, context & city stories', 'interest-culture.png', 'Explore the layers behind Beijing’s monumental places.'],
        ['Temples & Traditions', 'Ritual, design & living culture', 'curated-tours-beijing.png', 'Look closer at the ideas woven through historic sites.'],
        ['Heritage in Detail', 'Craft, symbols & everyday history', 'interest-hutong.png', 'Follow the details that make the city distinctive.']
      ]
    },
    food: {
      title: 'Food & Flavors', topics: 'TASTE   TRADITION   LOCAL TABLES',
      tagline: 'Discover Beijing through what it eats.',
      description: 'Food offers another way into the city. Choose a culinary perspective and we’ll shape the route and tastings around your interests and preferences.',
      choice: 'Choose your flavor of Beijing.', hero: 'interest-food.png',
      ideal: 'Food interests', style: 'Food',
      features: [
        ['Local flavors', 'A taste-led view of the city.', 'interest-food.png'],
        ['Food stories', 'Context behind the dishes and places.', 'interest-hutong.png'],
        ['Your preferences', 'A plan shaped around what you enjoy.', 'interest-night.png']
      ],
      listings: [
        ['Neighborhood Flavors', 'Local streets & food stories', 'interest-food.png', 'Follow the flavors that make a neighborhood memorable.'],
        ['Tea & Traditions', 'A slower food-and-culture perspective', 'interest-hutong.png', 'Make room for stories behind Beijing’s everyday rituals.'],
        ['After-Dark Bites', 'Evening atmosphere & local tastes', 'interest-night.png', 'Explore the city through its evening food culture.']
      ]
    },
    views: {
      title: 'Views & Photography', topics: 'LIGHT   CITYSCAPES   PERSPECTIVES',
      tagline: 'Find your own frame of Beijing.',
      description: 'From historic silhouettes to contemporary horizons, choose the kind of view that inspires you. Timing and locations are tailored to your plans.',
      choice: 'Choose a perspective on the city.', hero: 'interest-photography.png',
      ideal: 'Photography interests', style: 'Views',
      features: [
        ['City views', 'A sense of Beijing’s scale and layers.', 'interest-photography.png'],
        ['Changing light', 'Consider the city at different moments.', 'curated-tours-beijing.png'],
        ['Personal perspective', 'Make space for your own eye.', 'interest-great-wall.png']
      ],
      listings: [
        ['Beijing from Above', 'Rooftops, horizons & perspective', 'interest-photography.png', 'See the city’s historic and modern layers together.'],
        ['Golden Hour Walk', 'Light, streets & city moments', 'curated-tours-beijing.png', 'Follow the city as its mood changes with the light.'],
        ['Walls & Horizons', 'Open views beyond the center', 'interest-great-wall.png', 'Find a broader perspective on Beijing’s landscape.']
      ]
    },
    art: {
      title: 'Art & Modern Beijing', topics: 'CREATIVITY   DESIGN   NEW CITY',
      tagline: 'See the city’s creative side.',
      description: 'Explore contemporary Beijing through art, architecture and the people shaping what comes next. Choose the angle that speaks to you.',
      choice: 'Choose your creative perspective.', hero: 'interest-modern.png',
      ideal: 'Art & design interests', style: 'Modern Beijing',
      features: [
        ['Creative places', 'A closer look at spaces for ideas.', 'interest-modern.png'],
        ['Modern architecture', 'Notice the city’s changing forms.', 'interest-photography.png'],
        ['New perspectives', 'Connect contemporary life with context.', 'interest-culture.png']
      ],
      listings: [
        ['Creative Beijing', 'Art spaces & city ideas', 'interest-modern.png', 'Follow the creative energy of the capital.'],
        ['Design & Districts', 'Architecture & contemporary neighborhoods', 'interest-photography.png', 'Explore the shapes and spaces of modern Beijing.'],
        ['New City Stories', 'People, places & the present', 'interest-culture.png', 'Look at how the city continues to evolve.']
      ]
    },
    night: {
      title: 'Beijing After Dark', topics: 'EVENING   LIGHT   LOCAL LIFE',
      tagline: 'A different city as night falls.',
      description: 'Evening reveals another side of Beijing. Choose the atmosphere you want to experience, then shape timing and details around your plans.',
      choice: 'Choose your evening in Beijing.', hero: 'interest-night.png',
      ideal: 'Evening interests', style: 'After Dark',
      features: [
        ['City lights', 'See familiar places in a new mood.', 'interest-night.png'],
        ['Evening streets', 'Notice the rhythm of local life.', 'interest-hutong.png'],
        ['Night flavors', 'Food can be part of the story.', 'interest-food.png']
      ],
      listings: [
        ['After-Dark Beijing', 'Evening streets & atmosphere', 'interest-night.png', 'Discover the city’s changing character after sunset.'],
        ['City Lights', 'Architecture & night perspectives', 'interest-modern.png', 'See Beijing’s forms and colors in the evening.'],
        ['Evening Flavors', 'Food, streets & local rhythm', 'interest-food.png', 'Follow the sensory side of the city at night.']
      ]
    }
  };
  Object.entries(window.JB_SERIES_CATEGORIES || {}).forEach(([key, value]) => { if (series[key]) Object.assign(series[key], value); });
  if (window.JB_SERIES_CATEGORIES?.['2-days:family'] || window.JB_SERIES_CATEGORIES?.['5-days:family'] || window.JB_SERIES_CATEGORIES?.['7-days:family']) series.family = { ...series.culture, title: 'Family Discovery' };
  if (window.JB_SERIES_CATEGORIES?.['3-days:gardens'] || window.JB_SERIES_CATEGORIES?.['5-days:gardens'] || window.JB_SERIES_CATEGORIES?.['7-days:gardens']) series.gardens = { ...series.culture };
  const params = new URLSearchParams(location.search);
  const routeContext = window.JB_ROUTE_CONTEXT;
  const durationKey = routeContext?.duration || (Object.hasOwn(durations, params.get('duration')) ? params.get('duration') : '3-hours');
  const routeSeries = Object.entries({"hutongs":"hutongs-local-life","culture":"imperial-beijing","food":"beijing-food-tours","views":"beijing-photography-tours","art":"modern-beijing","night":"beijing-after-dark"}).find(([, handle]) => location.pathname.endsWith('/' + handle))?.[0];
  const seriesKey = routeContext?.series || (Object.hasOwn(series, params.get('series')) ? params.get('series') : routeSeries || 'hutongs');
  const isThreeFour = durationKey === '3-days' || durationKey === '4-days' || durationKey === '5-days' || durationKey === '7-days';
  const duration = durations[durationKey];
  const category = series[seriesKey];
  Object.assign(category, (window.JB_SERIES_CATEGORIES || {})[durationKey + ':' + seriesKey] || {});
  const assets = {"home-cover-editorial.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-home-cover-editorial.png?v=1790587501","curated-tours-beijing.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-curated-tours-beijing.png?v=1790587566","home-light-shadow.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-home-light-shadow.png?v=1790587584","interest-culture.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-culture.png?v=1790587609","interest-family.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-family.png?v=1790587632","interest-food.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-food.png?v=1790587712","interest-great-wall.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-great-wall.png?v=1790587738","interest-hutong.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-hutong.png?v=1790587759","interest-modern.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-modern.png?v=1790587774","interest-night.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-night.png?v=1790588135","interest-photography.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-interest-photography.png?v=1790588154","open-book-ivory-editorial.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-open-book-ivory-editorial.png?v=1790588173","stories-traveler-placeholder.png":"https://cdn.shopify.com/s/files/1/0744/1416/2010/files/jingbound-stories-traveler-placeholder.png?v=1790588189"};
  const asset = name => name.startsWith('asset:') ? (window.JB_ROUTE_ASSETS || {})[name.slice(6)] || (window.JB_TWO_DAY_ASSETS || {})[name.slice(6)] || (window.JB_FIVE_DAY_ASSETS || {})[name.slice(6)] || (window.JB_SEVEN_DAY_ASSETS || {})[name.slice(6)] || name : name.startsWith('video:') ? name : assets[name] || name;
  const setText = (id, value) => { document.getElementById(id).textContent = value; };
  const createMedia = (name, alt = '') => { const value = asset(name); const video = value.startsWith('video:'); const element = document.createElement(video ? 'video' : 'img'); if (video) { element.src = value.slice(6); element.autoplay = true; element.muted = true; element.loop = true; element.playsInline = true; element.setAttribute('aria-label', alt); } else { element.src = value; element.alt = alt; } return element; };
  const setImage = (id, name, alt) => { const current = document.getElementById(id); if (isThreeFour && !name) { current.hidden = true; return; } const next = createMedia(name, alt); next.id = id; next.className = current.className; current.replaceWith(next); };
  const url = (page, item) => {
    const target = new URL(page === 'listing' ? '/pages/private-beijing-tours' : '/pages/' + {"hutongs":"hutongs-local-life","culture":"imperial-beijing","food":"beijing-food-tours","views":"beijing-photography-tours","art":"modern-beijing","night":"beijing-after-dark"}[seriesKey], location.origin);
    target.searchParams.set('duration', durationKey);
    target.searchParams.set('series', seriesKey);
    if (item !== undefined) target.searchParams.set('journey', String(item + 1));
    return target.href;
  };

  if (document.body.classList.contains('series-page')) {
    document.querySelectorAll('[data-credit-key]').forEach(credits => {
      credits.hidden = credits.dataset.creditKey !== durationKey + ':' + seriesKey;
    });
    document.title = `${category.title} · ${duration} — Jingbound`;
    document.getElementById('series-back').href = '/pages/' + durationKey + '-in-beijing';
    setText('series-topics', category.topics);
    setText('series-title', category.title);
    setText('series-tagline', category.tagline);
    setText('series-description', category.description);
    setText('series-subtitle', category.choice);
    setImage('series-hero', category.hero, category.title + ' in Beijing');
    const list = document.getElementById('journey-list');
    category.listings.forEach((item, index) => {
      const link = document.createElement('a');
      link.className = 'deep-journey-card';
      if (index === 0) link.classList.add('is-featured');
      link.href = url('listing', index);
      const image = createMedia(item[2], item[0] + ' concept image');
      const copy = document.createElement('span');
      copy.className = 'deep-journey-copy';
      const number = document.createElement('small');
      number.textContent = String(index + 1).padStart(2, '0');
      const title = document.createElement('strong');
      title.textContent = item[0];
      const detail = document.createElement('em');
      detail.textContent = item[1];
      const arrow = document.createElement('b');
      arrow.textContent = '→';
      arrow.setAttribute('aria-hidden', 'true');
      copy.append(number, title, detail, arrow);
      link.append(image, copy);
      list.append(link);
    });
    list.querySelectorAll('a').forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) location.assign(link.href);
      else {
        document.querySelector('.journey-book').classList.add('is-leaving');
        setTimeout(() => location.assign(link.href), 650);
      }
    }));
  }

  if (document.body.classList.contains('listing-page')) {
    const rawIndex = Number(routeContext?.journey || params.get('journey')) - 1;
    const index = Number.isInteger(rawIndex) && rawIndex >= 0 && rawIndex < category.listings.length ? rawIndex : 0;
    const item = category.listings[index];
    const listingDetails = window.JB_LISTING_DETAILS || {};
    const editable = listingDetails[durationKey + ':' + seriesKey + ':' + (index + 1)] || listingDetails[seriesKey + ':' + (index + 1)];
    const routeEditorial = (window.JB_ROUTE_EDITORIAL || {})[durationKey + ':' + seriesKey + ':' + (index + 1)];
    const editorial = routeEditorial?.title ? routeEditorial : null;
    const durationAdjective = duration.replace(' ', '-').replace(/s$/, '');
    document.title = `${item[0]} | Private ${durationAdjective} Beijing Journey — Jingbound`;
    document.querySelector('meta[name="description"]').content = `${item[0]}: a private ${durationAdjective.toLowerCase()} Beijing journey concept. ${item[3]} Request a tailored proposal from Jingbound.`;
    if (editorial?.title) document.title = editorial.title;
    if (editorial?.description) document.querySelector('meta[name="description"]').content = editorial.description;
    const durationHandle = durationKey + '-in-beijing';
    document.getElementById('listing-back').href = '/pages/' + durationHandle;
    try {
      const saved = JSON.parse(sessionStorage.getItem('jb-catalog-return'));
      const source = saved && new URL(saved.url, location.origin);
      const route = saved && new URLSearchParams(saved.route);
      const validPath = source?.pathname === '/' || /^\/pages\/(3-hours|1-day|[23457]-days)-in-beijing$/.test(source?.pathname || '');
      if (source?.origin === location.origin && validPath && Date.now() - saved.savedAt < 86400000 &&
          route.get('duration') === durationKey && route.get('series') === seriesKey && route.get('journey') === String(index + 1)) {
        const back = document.getElementById('listing-back');
        back.href = source.href;
        if (saved.label) back.textContent = saved.label;
      }
    } catch {}
    setText('listing-title', item[0]);
    setText('listing-best-for', category.ideal);
    setText('route-lede', `${duration} in Beijing · ${item[3]}`);
    setText('reading-kicker', `${category.title.toUpperCase()} / PRIVATE ${duration.toUpperCase()} JOURNEY`);
    setText('reading-title', `Explore ${item[0]}`);
    setText('reading-intro', `${item[3]} We can use ${item[1]} as a starting point for the conversation, not a fixed itinerary. Tell us what draws you in, and we can shape the route around your interests, group and pace.`);
    const readingFocus = {
      hutongs: 'The interest here is in the relationship between old streets and present-day neighborhood life: details of architecture, small everyday rhythms and stories that are easy to miss when moving quickly. We can discuss the places that make the most sense for your visit without assuming access to private homes or courtyards.',
      culture: 'Look beyond a landmark photograph to the design, symbolism and city history around it. Your preferred depth of context can guide the balance between major sights, quieter details and time to absorb each place. Any entrance or access arrangements are confirmed separately.',
      food: 'Use flavor as a way to understand the city: streets, food traditions and the stories behind them. Share dietary needs and the experiences you are comfortable with; any tasting, meal or venue arrangements are confirmed in your proposal.',
      views: 'The visual story can move between old roofs, open landscapes and the contemporary skyline. Tell us whether you care most about architecture, street scenes or changing light; viewpoints and timing depend on the day and access conditions.',
      art: 'Explore the creative side of Beijing through spaces, design and contemporary city life. The mix can lean toward architecture, galleries or neighborhood culture, with venue availability and any entry arrangements checked before confirmation.',
      night: 'See how Beijing changes in the evening, from the atmosphere of its streets to illuminated architecture or food culture. The final timing, transport and venues are planned around your preferences and what is operating on your date.'
    };
    const listingAngles = {
      hutongs: [
        'Hutong Stories puts the street itself at the center: how lanes meet public spaces, what the details of old buildings reveal, and how local life continues around them.',
        'White Pagoda & Hidden Hutongs looks toward the Baitasi neighborhood and the smaller streets around Gongmenkou and Xisi. The interest is not a checklist of monuments but the contrast between a recognizable landmark and the texture of nearby lanes.',
        'Courtyards & Everyday Life follows the idea of shared streets and inward-looking architecture. Dongsi and Shijia Hutong are useful reference points for discussing what kind of neighborhood perspective appeals to you.'
      ],
      culture: [
        'Imperial Perspectives considers scale, layout and the stories behind Beijing’s monumental spaces, with time to connect a landmark to the city around it.',
        'Temples & Traditions is about the ideas behind historic places: ritual, symbolism and architecture, considered with sensitivity to places that remain part of everyday life.',
        'Heritage in Detail rewards close observation. Materials, motifs and the small choices of a building can reveal more than a hurried overview.'
      ],
      food: [
        'Neighborhood Flavors follows the relationship between a local street and the food culture around it, from familiar dishes to the context in which people enjoy them.',
        'Tea & Traditions makes space for a slower conversation about everyday rituals and the social life around food and drink.',
        'After-Dark Bites takes the city’s evening appetite as its lens: shifting street atmosphere, local tastes and the choices that suit your own preferences.'
      ],
      views: [
        'Beijing from Above is a study in layers: rooflines, long horizons and the distance between historic forms and newer towers.',
        'Golden Hour Walk is led by changing light. We can discuss the kind of scene you want to photograph, then consider practical timing and access.',
        'Walls & Horizons looks for a sense of openness beyond the dense center, with the landscape and your travel time both part of the planning.'
      ],
      art: [
        'Creative Beijing considers how artists and designers use space in a fast-changing city, from contemporary districts to smaller creative corners.',
        'Design & Districts focuses on the built environment: contrasting materials, scales and the way modern neighborhoods are used.',
        'New City Stories treats contemporary Beijing as a living subject, connecting urban change with the people and places you are curious about.'
      ],
      night: [
        'After-Dark Beijing follows the change of pace when daylight fades, paying attention to street life and the mood of familiar places.',
        'City Lights takes architecture after sunset as its starting point, from silhouettes to illuminated contemporary forms.',
        'Evening Flavors looks at the connection between food and night-time streets, with choices guided by your tastes and dietary needs.'
      ]
    };
    setText('reading-focus', `${listingAngles[seriesKey]?.[index] || item[3]} ${readingFocus[seriesKey] || ''}`);
    setText('reading-pace', durationKey === '3-hours'
      ? 'Three hours offers one focused perspective rather than a race through a checklist. We can prioritize the places and moments you care about most, allow room for a pause, and adjust walking to your group. The sequence shown in the book is an editorial example, not a booking commitment.'
      : `With ${duration.toLowerCase()}, there is more room to balance key sights with unhurried discoveries. We can discuss the number of stops, walking and transport, rest time and your group's interests before proposing a day-by-day shape. The book above is illustrative rather than a fixed schedule.`);
    setText('reading-details', 'Please share your travel date, group size, mobility or accessibility needs, starting area and any must-see interests when enquiring. We will confirm the exact route, meeting point, guide or transport arrangements, entrance requirements and price in a tailored proposal. Images on this page illustrate the theme and may not depict a proposed stop.');
    if (seriesKey === 'hutongs' && index === 1) document.getElementById('reading-source').hidden = false;
    if (editable) { setText('reading-intro', editable.intro); setText('reading-focus', editable.focus); setText('reading-pace', editable.pace); setText('reading-details', editable.details); document.getElementById('reading-source').hidden = !editable.sourceVisible; }
    if (editorial) {
      const facts = document.querySelectorAll('.listing-practical-facts section p');
      if (editorial.meeting) facts[0].textContent = editorial.meeting;
      if (editorial.walking) facts[1].textContent = editorial.walking;
      if (editorial.bestFor) setText('listing-best-for', editorial.bestFor);
      const pairs = (editorial.faq || '').split('\n').map(line => {
        const separator = line.indexOf('|');
        return separator < 0 ? [] : [line.slice(0, separator).trim(), line.slice(separator + 1).trim()];
      }).filter(pair => pair[0] && pair[1]);
      const bookFaq = document.querySelector('.listing-practical-title').parentElement.querySelector('.listing-faq');
      const readingFaq = document.getElementById('listing-reading-faq');
      if (routeContext) {
        readingFaq.replaceChildren();
        document.getElementById('listing-route-sources').replaceChildren();
      }
      if (pairs.length) {
        bookFaq.querySelectorAll('details').forEach(detail => detail.remove());
        pairs.forEach(([question, answer], position) => {
          const detail = document.createElement('details');
          detail.open = position === 0;
          const summary = document.createElement('summary'); summary.textContent = question;
          const paragraph = document.createElement('p'); paragraph.textContent = answer;
          detail.append(summary, paragraph);
          if (position < 3) bookFaq.append(detail);
          else { detail.open = true; readingFaq.append(detail); }
        });
        document.getElementById('listing-reading-editorial').hidden = false;
      }
      (editorial.sources || '').split('\n').forEach(line => {
        const [label, href] = line.split('|').map(part => part.trim());
        if (!label || !/^https:\/\/(?:www\.dpm\.org\.cn|english\.beijing\.gov\.cn|www\.mutianyugreatwall\.com|(?:www\.)?cstm\.org\.cn|(?:english\.|s\.|www\.)visitbeijing\.com\.cn|www\.capitalmuseum\.org\.cn|www\.artmuseum\.tsinghua\.edu\.cn|www\.universalbeijingresort\.com|www\.chnbg\.cn|www\.nnhm\.org\.cn|www\.gubeiwatertown\.com|pcticket\.chnmuseum\.cn)\//.test(href || '')) return;
        const row = document.createElement('li');
        const link = document.createElement('a'); link.href = href; link.textContent = label;
        link.target = '_blank'; link.rel = 'noopener noreferrer';
        row.append(link); document.getElementById('listing-route-sources').append(row);
      });
    }
    const dayDepth = (window.JB_DAY_DEPTH || {})[durationKey + ':' + seriesKey + ':' + (index + 1)];
    if (['1-day', '2-days', '3-days', '4-days', '5-days', '7-days'].includes(durationKey) && dayDepth?.start && dayDepth?.middle && dayDepth?.end) {
      setText('listing-day-start', dayDepth.start);
      setText('listing-day-middle', dayDepth.middle);
      setText('listing-day-end', dayDepth.end);
      document.getElementById('listing-day-depth').hidden = false;
      if (durationKey === '2-days') {
        document.body.classList.add('listing-two-day');
        const labels = window.JB_TWO_DAY_LABELS;
        const heading = document.querySelector('.listing-day-depth-heading');
        heading.querySelector('span').textContent = labels.kicker;
        heading.querySelector('h3').textContent = labels.title;
        document.querySelectorAll('.listing-day-depth-cards small').forEach((node, i) => { node.textContent = labels.days[i]; });
        document.querySelectorAll('.listing-practical-cards p').forEach((node, i) => { node.textContent = labels.scope[i]; });
        document.querySelector('.listing-reading-image figcaption').textContent = labels.photoNote;
        document.querySelectorAll('.listing-plan, .listing-reading-end a').forEach(link => {
          const target = new URL(link.href); target.searchParams.set('trip_days', '2');
          target.searchParams.set('trip_route', item[0]); link.href = target.href;
        });
      }
    }

    if (isThreeFour && dayDepth) {
      const labels = window.JB34_LABELS;
      document.body.classList.add('listing-multi-day');
      if (durationKey === '5-days' || durationKey === '7-days') document.body.classList.add('listing-five-day');
      setText('route-lede', `${duration} in Beijing · ${category.topics}`);
      document.querySelector('.listing-reading-image figcaption').textContent = labels.photoNote;
      const back = document.getElementById('listing-back'); back.textContent = '← ' + (durationKey === '3-days' ? labels.backThree : durationKey === '7-days' ? window.JB7_LABELS.back : durationKey === '5-days' ? labels.backFive : labels.backFour);
      const heading = document.querySelector('.listing-day-depth-heading'); heading.querySelector('span').textContent = duration.toUpperCase(); heading.querySelector('h3').textContent = labels.title;
      const cards = document.querySelector('.listing-day-depth-cards');
      const extraDays = durationKey === '7-days' ? [dayDepth.four, dayDepth.five, dayDepth.six, dayDepth.seven] : durationKey === '5-days' ? [dayDepth.four, dayDepth.five] : durationKey === '4-days' ? [dayDepth.four] : [];
      if (!routeContext || cards.children.length === 3) extraDays.forEach(text => { const card = document.createElement('article'); const small = document.createElement('small'); const copy = document.createElement('p'); copy.textContent = text; card.append(small, copy); cards.append(card); });
      cards.querySelectorAll('small').forEach((node, i) => { node.textContent = labels.day + ' ' + (i + 1); });
      document.querySelectorAll('.listing-practical-cards p').forEach((node, i) => { node.textContent = labels.scope[i]; });
      document.querySelectorAll('.listing-plan, .listing-reading-end a').forEach(link => { const target = new URL(link.href); target.searchParams.set('trip_days', durationKey.slice(0, 1)); target.searchParams.set('trip_route', item[0]); link.href = target.href; });
      if (durationKey === '5-days') {
        document.querySelectorAll('.listing-plan, .listing-reading-end a').forEach(link => { link.firstChild.textContent = labels.ctaFive + ' '; });
      }
    }
    if (editable?.photoCredits) {
      const credits = document.getElementById('listing-photo-credits');
      const list = document.getElementById('listing-photo-credits-list');
      if (routeContext) list.replaceChildren();
      editable.photoCredits.split('\n').forEach(line => {
        const [label, author, license, source] = line.split('|').map(part => part.trim());
        if (!label || !author || !license || !/^https:\/\/commons\.wikimedia\.org\/wiki\/File:/i.test(source || '')) return;
        const item = document.createElement('li');
        const photo = document.createElement('a'); photo.href = source; photo.target = '_blank'; photo.rel = 'noopener noreferrer'; photo.textContent = label;
        const licenseLink = document.createElement('a');
        const version = license.match(/\d+(?:\.\d+)?/);
        licenseLink.href = license.startsWith('CC0') ? 'https://creativecommons.org/publicdomain/zero/1.0/' : `https://creativecommons.org/licenses/${license.includes('BY-SA') ? 'by-sa' : 'by'}/${version?.[0] || '4.0'}/`;
        licenseLink.target = '_blank'; licenseLink.rel = 'noopener noreferrer'; licenseLink.textContent = license;
        item.append(photo, document.createTextNode(` — ${author} · `), licenseLink);
        list.append(item);
      });
      credits.hidden = !list.childElementCount;
      if (durationKey === '7-days' && window.JB7_PHOTO_NOTE) credits.querySelector('p').textContent = window.JB7_PHOTO_NOTE;
      if (durationKey === '5-days' && window.JB5_PHOTO_NOTE) credits.querySelector('p').textContent = window.JB5_PHOTO_NOTE;
    }
    const hutongRoute = [
      ['Drum Tower', 'Iconic city views', 'interest-culture.png'],
      ['Baochao Hutong', 'Historic local lanes', 'interest-hutong.png'],
      ['Courtyard Lanes', 'Quiet corners', 'interest-hutong.png'],
      ['Shichahai', 'Lakeside perspective', 'interest-photography.png'],
      ['Tea Break', 'A moment to pause', 'interest-food.png']
    ];
    const conceptRoute = [
      ['Meet & orient', 'Starting point to confirm', item[2]],
      ['First perspective', 'Place to be tailored', category.hero],
      ['Closer look', 'Experience to confirm', category.features[0][2]],
      ['A local pause', 'Timing to be tailored', category.features[1][2]],
      ['Final moment', 'Finish to be confirmed', category.features[2][2]]
    ];
    const pagodaRoute = [
      ['Baitasi area', 'White Pagoda neighborhood context', 'interest-hutong.png'],
      ['Gongmenkou', 'Lanes and street life to explore', 'interest-hutong.png'],
      ['Xisi streets', 'Architecture and local details', 'interest-hutong.png'],
      ['A slower pause', 'Time to notice the neighborhood', 'interest-hutong.png'],
      ['Flexible finish', 'End point to be agreed', 'interest-hutong.png']
    ];
    const route = (editable?.stops || (seriesKey === 'hutongs' && durationKey === '3-hours' && index === 0 ? hutongRoute : seriesKey === 'hutongs' && durationKey === '3-hours' && index === 1 ? pagodaRoute : conceptRoute)).filter(stop => !isThreeFour || stop[0]);
    const timeline = document.getElementById('route-timeline');
    if (routeContext) timeline.replaceChildren();
    const thumbs = document.getElementById('route-thumbs');
    const media = (window.JB_LISTING_MEDIA || {})[durationKey + ':' + seriesKey + ':' + (index + 1)] || (window.JB_LISTING_MEDIA || {})[seriesKey + ':' + (index + 1)] || {};
    let gallery = (isThreeFour ? editable.stops : route).map((stop, position) => ({ src: stop[2], label: media.subjects?.split('\n')[position] || stop[0] || `Journey image ${position + 1}` }));
    (durationKey === '7-days' ? [media.extras?.[2]] : [media.extras?.[0] || media.readingPhoto || editable?.readingImage || item[2], media.extras?.[1] || category.hero, media.extras?.[2] || item[2]]).forEach((src, position) => gallery.push({ src, label: editorial?.galleryLabels?.[durationKey === '7-days' ? 2 : position] || `Journey image ${position + 6}` }));
    if (media.video) gallery.push({ src: `video:${media.video}`, label: 'Journey video' });
    if (isThreeFour) gallery = gallery.filter(entry => entry.src);
    const slotGallery = window.JBListingEditor?.gallery();
    if (slotGallery?.length) gallery = slotGallery;
    const dots = document.getElementById('reading-dots');
    let galleryIndex = 0;
    let galleryVisible = false;
    const showGallery = selected => {
      galleryIndex = (selected + gallery.length) % gallery.length;
      const entry = gallery[galleryIndex];
      setImage('reading-image', entry.src, `${entry.label} · ${category.title} in Beijing`);
      const activeMedia = document.getElementById('reading-image');
      if (activeMedia.tagName === 'VIDEO') { activeMedia.pause(); activeMedia.autoplay = false; activeMedia.muted = false; activeMedia.loop = false; activeMedia.controls = true; }
      document.getElementById('reading-count').textContent = `${String(galleryIndex + 1).padStart(2, '0')} / ${String(gallery.length).padStart(2, '0')}`;
      window.JBListingEditor?.mediaChanged('gallery', galleryIndex);
      dots.querySelectorAll('button').forEach((button, position) => {
        button.classList.toggle('is-active', position === galleryIndex);
        button.setAttribute('aria-current', String(position === galleryIndex));
      });
    };
    gallery.forEach((entry, position) => {
      const button = document.createElement('button'); button.type = 'button';
      button.setAttribute('aria-label', `Show ${entry.label}`);
      button.addEventListener('click', () => showGallery(position));
      dots.append(button);
    });
    document.getElementById('reading-prev').addEventListener('click', () => showGallery(galleryIndex - 1));
    document.getElementById('reading-next').addEventListener('click', () => showGallery(galleryIndex + 1));
    if (gallery.length) showGallery(0);
    const galleryFrame = document.querySelector('.listing-reading-image');
    if (isThreeFour && !gallery.length) { galleryFrame.hidden = true; const note = document.createElement('p'); note.className = 'listing-media-pending'; note.textContent = window.JB34_LABELS.pending; galleryFrame.after(note); }
    galleryFrame.addEventListener('pointerenter', () => galleryFrame.dataset.paused = 'true');
    galleryFrame.addEventListener('pointerleave', () => delete galleryFrame.dataset.paused);
    galleryFrame.addEventListener('focusin', () => galleryFrame.dataset.paused = 'true');
    galleryFrame.addEventListener('focusout', event => { if (!galleryFrame.contains(event.relatedTarget)) delete galleryFrame.dataset.paused; });
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { galleryVisible = entries[0].isIntersecting; }, { threshold: .4 }); observer.observe(galleryFrame); window.JBListingEditor?.track(() => observer.disconnect()); }
    else galleryVisible = true;
    if (!window.Shopify?.designMode && !matchMedia('(prefers-reduced-motion: reduce)').matches) { const galleryTimer = setInterval(() => {
      if (gallery.length && galleryVisible && !galleryFrame.dataset.paused && !document.hidden && document.getElementById('reading-image').tagName !== 'VIDEO') showGallery(galleryIndex + 1);
    }, 5500); window.JBListingEditor?.track(() => clearInterval(galleryTimer)); }
    const showStop = selected => {
      const stop = route[selected];
      setImage('route-focus-image', stop[2], media.subjects?.split('\n')[selected] || (editorial ? `${stop[0]} · ${item[0]}, Beijing` : `Illustrative photograph for ${category.title.toLowerCase()} in Beijing`));
      if (durationKey === '5-days') {
        let pending = document.querySelector('.listing-route-focus > .listing-media-pending');
        if (!pending && !stop[2]) { pending = document.createElement('p'); pending.className = 'listing-media-pending'; pending.textContent = window.JB34_LABELS.pending; document.getElementById('route-focus-image').after(pending); }
        if (pending) pending.hidden = Boolean(stop[2]);
      }
      setText('route-focus-number', String(selected + 1).padStart(2, '0'));
      setText('route-focus-title', stop[0]);
      setText('route-focus-detail', stop[1]);
      timeline.querySelectorAll('button').forEach((button, position) => {
        button.classList.toggle('is-active', position === selected);
        button.setAttribute('aria-pressed', String(position === selected));
      });
      thumbs.querySelectorAll('button').forEach(button => button.classList.toggle('is-active', Number(button.dataset.stop) === selected));
      window.JBListingEditor?.mediaChanged('stop', selected);
    };
    route.forEach((stop, position) => {
      const row = document.createElement('li');
      const button = document.createElement('button'); button.type = 'button';
      const number = document.createElement('span'); number.textContent = String(position + 1);
      const copy = document.createElement('span');
      const title = document.createElement('strong'); title.textContent = stop[0];
      const detail = document.createElement('small'); detail.textContent = stop[1];
      copy.append(title, detail); button.append(number, copy); row.append(button); timeline.append(row);
      if (stop[2] && !isThreeFour) {
        const thumb = document.createElement('button'); thumb.type = 'button'; thumb.dataset.stop = String(position); thumb.setAttribute('aria-label', `Show ${stop[0]}`);
        const image = createMedia(stop[2]); image.loading = 'lazy'; image.decoding = 'async';
        thumb.append(image); thumbs.append(thumb);
        thumb.addEventListener('click', () => showStop(position));
      }
      button.addEventListener('click', () => showStop(position));
    });
    if (isThreeFour) route.map(stop => ({ src: stop[2], label: stop[0] })).forEach((entry, position) => {
      const thumb = document.createElement('button'); thumb.type = 'button'; thumb.dataset.stop = String(position); thumb.setAttribute('aria-label', `Show ${entry.label}`);
      const image = createMedia(entry.src, entry.label); image.loading = 'lazy'; image.decoding = 'async'; thumb.append(image); thumbs.append(thumb);
      thumb.addEventListener('click', () => {
        if (position < route.length) showStop(position);
        else {
          setImage('route-focus-image', entry.src, entry.label); setText('route-focus-title', entry.label); setText('route-focus-detail', ''); setText('route-focus-number', String(position + 1).padStart(2, '0'));
          timeline.querySelectorAll('button').forEach(button => { button.classList.remove('is-active'); button.setAttribute('aria-pressed', 'false'); });
          thumbs.querySelectorAll('button').forEach(button => button.classList.toggle('is-active', Number(button.dataset.stop) === position));
        }
      });
    });
    showStop(0);
    const layout = window.JB_LISTING_LAYOUT_LABELS;
    document.body.classList.add('listing-unified');
    const readingInner = document.querySelector('.listing-reading-inner');
    const fullPractical = document.createElement('section');
    fullPractical.className = 'listing-full-practical';
    fullPractical.id = 'listing-full-practical';
    const practicalHeading = document.createElement('h3');
    practicalHeading.textContent = layout.practicalLabel;
    fullPractical.append(practicalHeading);
    const fullCards = document.querySelector('.listing-practical-cards').cloneNode(true);
    const fullFacts = document.querySelector('.listing-practical-facts').cloneNode(true);
    fullFacts.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
    fullPractical.append(fullCards, fullFacts);
    const editorialSection = document.getElementById('listing-reading-editorial');
    readingInner.insertBefore(fullPractical, editorialSection);
    const shortCopy = (text, limit = 105) => {
      const sentence = text.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim() || text;
      if (sentence.length <= limit) return sentence;
      return sentence.slice(0, limit).replace(/\s+\S*$/, '') + '…';
    };
    document.querySelectorAll('.journey-sheet-right .listing-practical-cards p, .journey-sheet-right .listing-practical-facts p').forEach(node => {
      node.textContent = shortCopy(node.textContent.trim(), node.closest('.listing-practical-facts') ? 75 : 105);
    });
    const more = document.createElement('a');
    more.className = 'listing-details-link'; more.href = '#listing-full-practical'; more.textContent = layout.moreLabel + ' ↓';
    document.querySelector('.listing-practical-facts').after(more);
    const bookFaq = document.querySelector('.journey-sheet-right .listing-faq');
    const readingFaq = document.getElementById('listing-reading-faq');
    const existingQuestions = new Set(Array.from(readingFaq.querySelectorAll('summary'), node => node.textContent.trim()));
    const bookQuestions = Array.from(bookFaq.querySelectorAll('details'));
    bookQuestions.forEach(detail => {
      const question = detail.querySelector('summary').textContent.trim();
      if (!existingQuestions.has(question)) { const copy = detail.cloneNode(true); copy.open = false; readingFaq.append(copy); existingQuestions.add(question); }
    });
    Array.from(readingFaq.querySelectorAll('details')).forEach((detail, position) => {
      detail.id = 'listing-answer-' + position; detail.open = position === 0;
    });
    bookQuestions.forEach(detail => {
      const question = detail.querySelector('summary').textContent.trim();
      const target = Array.from(readingFaq.querySelectorAll('details')).find(node => node.querySelector('summary').textContent.trim() === question);
      const link = document.createElement('a'); link.className = 'listing-faq-link'; link.href = '#' + target.id;
      link.textContent = question + ' →';
      link.addEventListener('click', () => { target.open = true; });
      detail.replaceWith(link);
    });
    editorialSection.hidden = false;
    const proposalUrl = new URL('/?chapter=build-your-beijing', location.origin);
    proposalUrl.searchParams.set('trip_duration', durationKey);
    if (durationKey !== '3-hours') proposalUrl.searchParams.set('trip_days', durationKey.split('-')[0]);
    proposalUrl.searchParams.set('trip_route', item[0]);
    proposalUrl.searchParams.set('trip_series', seriesKey);
    proposalUrl.searchParams.set('trip_journey', String(index + 1));
    document.querySelectorAll('.listing-plan, .listing-reading-end a').forEach(link => {
      link.href = proposalUrl.href;
      link.firstChild.textContent = layout.ctaLabel + ' ';
    });
    const depth = document.getElementById('listing-day-depth');
    if (durationKey === '3-hours' && depth.hidden) {
      depth.hidden = false;
      depth.querySelector('.listing-day-depth-heading span').textContent = duration.toUpperCase();
      depth.querySelector('h3').textContent = layout.itineraryLabel;
      const cards = depth.querySelector('.listing-day-depth-cards'); cards.replaceChildren();
      route.forEach((stop, position) => {
        const card = document.createElement('article'); const number = document.createElement('small');
        const title = document.createElement('h4'); const copy = document.createElement('p');
        number.textContent = String(position + 1).padStart(2, '0'); title.textContent = stop[0]; copy.textContent = stop[1];
        card.append(number, title, copy); cards.append(card);
      });
    }
    if (!depth.hidden) {
      depth.id = 'listing-day-depth';
      depth.querySelector('h3').textContent = layout.itineraryLabel;
      depth.querySelectorAll('.listing-day-depth-cards article').forEach((card, position) => {
        if (durationKey === '1-day') card.querySelector('small').textContent = [layout.morningLabel, layout.middayLabel, layout.afternoonLabel][position];
        const chapterText = card.textContent.toLowerCase();
        const stop = durationKey === '3-hours' ? route[position] : durationKey === '1-day'
          ? route.find(entry => chapterText.includes(entry[0].replace(/\s+(area|streets|neighbourhood|neighborhood)$/i, '').toLowerCase()))
          : route.find(entry => new RegExp('^Day\\s*' + (position + 1) + '\\b', 'i').test(entry[0]));
        const source = stop?.[2];
        if (!source || source.startsWith('video:')) return;
        const image = createMedia(source, stop[0]); image.loading = 'lazy'; image.decoding = 'async';
        const copy = document.createElement('div'); copy.className = 'listing-day-copy'; copy.append(...card.childNodes);
        card.append(image, copy);
      });
    }
    if (media.video) {
      const videoSection = document.createElement('section'); videoSection.className = 'listing-journey-video';
      const heading = document.createElement('h3'); heading.textContent = layout.videoLabel;
      const video = document.createElement('video'); video.src = media.video; video.controls = true; video.preload = 'none'; video.playsInline = true;
      if (media.readingPhoto && !media.readingPhoto.startsWith('video:')) video.poster = media.readingPhoto;
      videoSection.append(heading, video); depth.before(videoSection);
    }
    window.JBListingEditor?.connect({ showStop, showGallery, shortCopy });
    document.getElementById('journey-spread').classList.add('is-visible');
  }
  const builderReturn = params.get('return_to');
  if (builderReturn && document.body.classList.contains('listing-page')) {
    try {
      const source = new URL(builderReturn, location.origin);
      if (source.origin === location.origin && source.pathname === '/' && source.searchParams.get('chapter') === 'build-your-beijing') {
        const back = document.getElementById('listing-back');
        const navigation = document.querySelector('.chapter-rail a[href*="chapter=build-your-beijing"] strong');
        if (back) {
          back.href = source.href;
          if (navigation) back.textContent = '← ' + navigation.textContent.replace(/^\s*03\s*/, '').trim();
        }
      }
    } catch {}
  }
  const enableScrollBack = parentLink => {
    if (!parentLink) return;
    let upward = 0;
    let lastWheel = 0;
    let readyAt = 0;
    let leaving = false;
    let wasBelowTop = scrollY > 8;
    addEventListener('scroll', () => {
      const belowTop = scrollY > 8;
      if (wasBelowTop && !belowTop) readyAt = performance.now() + 400;
      if (belowTop) upward = 0;
      wasBelowTop = belowTop;
    }, { passive: true });
    addEventListener('wheel', event => {
      const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1);
      if (delta > 0) upward = 0;
      if (leaving || event.defaultPrevented || event.ctrlKey || event.metaKey ||
          delta >= -4 || Math.abs(event.deltaX) > Math.abs(event.deltaY) ||
          scrollY > 8 || performance.now() < readyAt ||
          (event.target instanceof Element && event.target.closest('.contact-bookmark, input, textarea, select, [contenteditable="true"]'))) return;
      const now = performance.now();
      if (now - lastWheel > 850) upward = 0;
      lastWheel = now;
      upward += Math.min(120, -delta);
      if (upward < 180) return;
      leaving = true;
      const parent = new URL(parentLink.href, location.href);
      const previous = document.referrer ? new URL(document.referrer) : null;
      const fromParent = previous?.origin === parent.origin && previous.pathname === parent.pathname &&
        ['chapter', 'duration', 'series'].every(key => previous.searchParams.get(key) === parent.searchParams.get(key));
      const navigate = () => { if (fromParent) history.back(); else location.assign(parent.href); };
      const book = document.querySelector('.journey-book');
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !book) navigate();
      else {
        book.classList.add('is-leaving');
        setTimeout(navigate, 600);
      }
    }, { passive: true });
  };
  if (!window.Shopify?.designMode) enableScrollBack(document.getElementById('listing-back') || document.getElementById('series-back'));
};
window.JBInitializeDeepPages();